import Vue from 'vue'
import { timeSlot } from '@/util/catalog'
import { handleColors } from '@/util/colors'

import headerHost from './fragments/headerHost'
import headerRealties from './fragments/headerProperties'
import headerObservations from './fragments/headerObservations'
import headerClient from './fragments/headerClient'

const translate = (data) => Vue.i18n.translate(data)

const headerContent = (data) => {
  const type = data?.type
  const code = data?.code
  const date = data?.date
  const status = data?.status
  const slotSize = data?.slot_size

  return `
  <div class="mapServiceDetails__header d-block mb-2">
    <h2 class="d-block text-h5 mb-2">
      ${translate(`type.${type}`)}
    </h2>

    <p class="d-flex align-center caption mb-3">
      <span>
        <span class="v-chip v-chip--no-color theme--light v-size--small ${handleColors(status)}">
          ${translate(`status.${status}`)}
        </span>
      </span>
      <span>
        ${timeSlot(date, slotSize)}
      </span>
      <span class="grey--text text--darken-1">
        #${code}
      </span>
    </p>

    ${headerClient(data)}
    ${headerHost(data)}
    ${headerRealties(data)}
    ${headerObservations(data)}

    <hr class="v-divider theme--light my-3" />
  </div>
 `
}

export default headerContent
